<template>
    <div class="listBox">
        <a v-for="(item) in objList" :key="item.url" :href="item.url" target="_blank">
            <img :src=item.img alt="" class="img">
            <div class="title">
              <p>{{item.name}}</p>
            </div>
            <div class="tab">
                <p>{{item.classificationTwo}}</p>
            </div>
            <img class='top' v-if="item.flag == 'false' ? false : true" src="static/image/mao.png" alt="">
        </a>
    </div>
</template>

<script>
export default {
  props: {
    objList: {
      type: Array,
      default: "没有数据"
    }
  },
  return() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.listBox {
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px;
  > a {
    width: calc(50% - 20px);
    display: flex;
    flex-direction: column;
    text-decoration: none;
    margin: 0 10px 30px;
    position: relative;
    > img {
      width: 100%;
      border-radius: 8px;
    }
    > .title {
      margin-top: 20px;
      height: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > p {
        width: 80%;
        color: #333;
        font-size: 28px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    > .tab {
      display: flex;
      margin-top: 10px;
      > p {
        height: 32px;
        line-height: 32px;
        background: rgba(244, 242, 242, 1);
        border-radius: 16px;
        font-size: 24px;
        color: #999999;
        margin-right: 10px;
        padding: 4px 12px;
      }
    }
    > .top {
      width: 77px;
      height: 77px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue